<template>
  <div class="onboarding_page">
    <div class="page_content">
      <h2>😊 Välkommen till Memlist Onboarding</h2>
      <p>Denna wizard kommer att hjälpa dig att komma igång med Memlist.</p>

      <h4 class="mt-16">Har ni sett vår dokumentationssida?</h4>
      <p>På <a href="https://memlist.se/docs" target="_blank">memlist.se/docs</a> kan ni själv söka fram bland alla våra artiklar, guider och hjälpavsnitt.</p>
    
    </div>

    
    <div class="wizard_actions mt-4">
      
      <memlist-button variant="primary" class="ml-8" @click="next_page">Fortsätt</memlist-button>
    </div>

  </div>
</template>

<script>

export default {
  name: 'onboarding_page1',
  props: ['onboarding_data'],
  emits: ['next_page','update_data'],
  components: {
    
  },
  watch: {
    onboarding_data: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_onboarding_data = { ...this.onboarding_data };
      },
      immediate: true
    },
  },
  data() {
    return {
      local_onboarding_data: null,
    }
  },
  methods: {
    next_page() {
      this.local_onboarding_data.welcome_shown = true;
      this.local_onboarding_data.page1_next = true;

      // No additional data on this page.
      this.$emit('update_data', this.local_onboarding_data);
      this.$emit('next_page');
    }
  }
}
</script>

<style lang="scss" scoped>


</style>
